import { render, staticRenderFns } from "./AsignacionTurnoSection.vue?vue&type=template&id=85c0846c"
import script from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"
export * from "./AsignacionTurnoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports